<div class="flex flex-col sm:h-full sm:flex-row items-center">
    <div *ngIf="!showExternalLoginStepper" class="sm:w-3/5 sm:h-full w-full
        h-1/2 grid place-content-center
        bg-[#66bb6a]/10 max-sm:border-b border-[#66bb6a]">
        <landing-screen class="p-6 sm:p-32"></landing-screen>
    </div>
   <div *ngIf="!showExternalLoginStepper" class="ie-fix sm:w-2/5
        sm:h-full w-full h-1/2 px-10 grid
        place-items-center">
        <form *ngIf="isInternal" [formGroup]="internalLoginForm" class="flex flex-col w-3/5
            lg:w-1/2">
            <p class="text-3xl sm:text-4xl leading-loose font-bold
                text-green-700">Login to your account:</p>
            <!-- <h2>Login to your account:</h2> -->
            <mat-form-field appearance="outline">
                <input type="text" matInput placeholder="UserID/EmpID"
                    formControlName="userID">
                <mat-icon matPrefix class="material-icons-round">person</mat-icon>        
                <mat-hint>Hint: E123456 / N123456</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <input type="password" matInput placeholder="Password"
                    formControlName="password">
                <mat-icon matPrefix class="material-icons-round">lock</mat-icon>
            </mat-form-field>
            <button mat-raised-button (click)="login()"
                [disabled]="internalLoginForm.invalid ||
                pending" class="login-button" color="primary">LOGIN</button>
            <br>
            <h4  class="w-full items-center">OR</h4>
            <div class="w-full text-center">
                <button mat-raised-button color="primary" class="login-button"
                    (click)="tempBypassLogin()">Internal
                    Login</button>
            </div>
        </form>

        <form *ngIf="!isInternal"  [formGroup]="externalLoginForm" class="flex flex-col w-3/5
            lg:w-1/2">
            <p class="text-3xl sm:text-4xl leading-loose font-bold
                text-green-700">Login to your account:</p>
            <!-- <h2>Login to your account:</h2> -->
            <mat-form-field appearance="outline">
                <input type="text" matInput placeholder="Email"
                    formControlName="email">
                <mat-icon matPrefix class="material-icons-round">person</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <input type="password" matInput placeholder="Password"
                    formControlName="password">
                <mat-icon matPrefix class="material-icons-round">lock</mat-icon>
            </mat-form-field>
            <button mat-raised-button (click)="login()"
                [disabled]="externalLoginForm.invalid ||
                pending" class="login-button" color="primary">LOGIN</button>
            <br>
            <div class="w-full flex flex-row items-center
                content-center">
                <h3 class="w-1/2 font-medium flex content-center justify-center
                    p-6." style="text-decoration: bold;">
                    Need an
                    Account?
                </h3>
                <p matRipple matRippleColor="primary" class="w-1/2 action-button
                    primary-button"
                    (click)="openExternalRegistration()">Register</p>
            </div>
            <br> <br>
            <p *ngIf="!isInternal" class="font-medium underline text-[#66bb6a]
                cursor-pointer"
                [routerLink]="['/forgot-password']">Forgot
                Password</p>
        </form>
    </div>

    <div class="ie-fix w-full h-full grid px-4 sm:px-20 justify-center
        content-start items-center"
        *ngIf="showExternalLoginStepper">
        <div class="py-10">
            <button mat-raised-button color="primary" title="Login"
                (click)="closeExternalAccessForm()">
                <mat-icon>account_circle</mat-icon>
                Login
            </button>
        </div>
        <mat-stepper class="!w-full !border-2 !border-[#66bb6a] !rounded-2xl"
            [linear]="isLinear" orientation="vertical"
            #stepper
            style="overflow:auto">
            <mat-step [stepControl]="einFormGroup" [editable]="!isVerified"
                [completed]="isVerified && isLinear">
                <form [formGroup]="einFormGroup" #f1="ngForm">
                    <ng-template matStepLabel>Verify EIN</ng-template>
                    <mat-form-field>
                        <input type="text" EIN ngControl="EIN" matInput
                            maxlength="10" placeholder="Enter EIN"
                            formControlName="EINCtrl">
                    </mat-form-field>
                    <div *ngIf="!isEINValid && isVerified">
                        <p style="color: red">The exemption status of the Tax
                            ID/EIN entered was not validated. Please complete
                            required information about your organization on next
                            step</p>
                    </div>
                    <div fxLayout="row" fxLayoutGap="10px" style="padding-top:
                        10px">
                        <button mat-raised-button color="primary"
                            [disabled]="einFormGroup.invalid ||
                            profileSubmittedSuccessfully" (click)="verifyEIN()">Verify</button>
                        <button *ngIf="isVerified" mat-raised-button
                            matStepperNext color="primary">Next</button>
                    </div>

                </form>
            </mat-step>
            <mat-step [stepControl]="extOrgInfoFormGroup" [editable]="isVerified
                && !profileSubmittedSuccessfully"
                [completed]="extOrgInfoFormGroup.valid &&
                extOrgInfoFormGroup.dirty">
                <form [formGroup]="extOrgInfoFormGroup" #f2="ngForm">
                    <ng-template matStepLabel>{{isEINValid ?"Confirm
                        Organization Info" : "Organization Info"}}
                    </ng-template>
                    <mat-card fxLayout="column">
                        <mat-card-subtitle *ngIf="isEINValid">
                            <b>Organization Information</b>
                            <p>Please edit the mailing address below if needed.
                            </p>
                        </mat-card-subtitle>
                        <mat-card-subtitle *ngIf="!isEINValid">
                            <b>Organization Information</b>
                            <p style="color: red">The exemption status of the
                                Tax ID/EIN entered was not validated. Please
                                complete the below required information about
                                your organization.</p>
                        </mat-card-subtitle>

                        <mat-form-field>
                            <input [attr.disabled]="isEINValid" type="text"
                                matInput placeholder="Organization Name"
                                formControlName="name">
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" matInput placeholder="EIN
                                " maxlength="10" formControlName="EIN" readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf="isEINValid">
                            <input type="text" matInput placeholder="Tax
                                Exempt Status" maxlength="20"
                                [value]="getTaxExemptStatus(extOrgInfoFormGroup.value.subsection_501)"
                                readonly>
                        </mat-form-field>
                        <mat-form-field *ngIf='!isEINValid'>
                            <mat-select placeholder="Tax Exempt Status
                                " formControlName="subsection_501"
                                [disabled]='isReadOnly'>
                                <mat-option *ngFor="let subsection of
                                    taxExcemptList" [value]="subsection">
                                    {{getTaxExemptStatus(subsection)}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" matInput placeholder="Web
                                Address" maxlength="250"
                                formControlName="webAddress">
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" matInput placeholder="Address1"
                                maxlength="35" formControlName="address1">
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" matInput placeholder="Address2"
                                maxlength="35" formControlName="address2">
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" matInput placeholder="City"
                                maxlength="50" formControlName="city">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-select
                                [disabled]="profileSubmittedSuccessfully"
                                placeholder="State" formControlName="state">
                                <mat-option
                                    [disabled]="profileSubmittedSuccessfully"
                                    *ngFor="let state of states"
                                    [value]="state">{{state}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" zipCode matInput placeholder="Zip
                                Code" maxlength="9" formControlName="zipCode">
                        </mat-form-field>
                    </mat-card>

                    <div fxLayoutGap="10px" style="padding-top: 10px">
                        <button mat-raised-button matStepperNext color="primary"
                            [disabled]="extOrgInfoFormGroup.invalid"
                            (click)="extOrgInfoFormGroup.markAsDirty();">Next</button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="extOrgContactInfoFormGroup"
                [editable]="isVerified && !profileSubmittedSuccessfully"
                [completed]="extOrgContactInfoFormGroup.valid &&
                extOrgContactInfoFormGroup.dirty">
                <form [formGroup]="extOrgContactInfoFormGroup" #f3="ngForm">
                    <ng-template matStepLabel>Add Contact Info</ng-template>
                    <mat-card fxLayout="column">
                        <mat-card-subtitle>
                            <b>Organization Contact Information</b>
                        </mat-card-subtitle>
                        <br> <br>
                        <mat-card-subtitle style="font-weight:bold">Primary
                            Contact
                        </mat-card-subtitle>
                        <mat-form-field>
                            <input type="text" matInput placeholder="First
                                Name" maxlength="150"
                                formControlName="firstName">
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" matInput placeholder="Last
                                Name" maxlength="150"
                                formControlName="lastName">
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" phone ngControl="phone" matInput
                                placeholder="Phone Number" maxlength="12"
                                formControlName="phone">
                            <mat-hint>Example: XXX-XXX-XXXX</mat-hint>
                        </mat-form-field>
                        <mat-form-field>
                            <input type="email" matInput placeholder="Email
                                Address" maxlength="254"
                                formControlName="email">
                            <mat-hint>Example: you@example.com</mat-hint>
                        </mat-form-field>
                        <div *ngIf="secondaryContactIncluded">
                            <br> <br>
                            <br> <br>
                            <mat-card-subtitle style="font-weight:bold">Secondary
                                Contact
                            </mat-card-subtitle>
                            <mat-form-field>
                                <input type="text" matInput placeholder="First
                                    Name" maxlength="150"
                                    formControlName="secondaryFirstName">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" matInput placeholder="Last
                                    Name" maxlength="150"
                                    formControlName="secondaryLastName">
                            </mat-form-field>
                            <mat-form-field>
                                <input type="text" phone ngControl="phone"
                                    matInput placeholder="Phone Number
                                    " maxlength="12"
                                    formControlName="secondaryPhone">
                                <mat-hint>Example: XXX-XXX-XXXX</mat-hint>
                            </mat-form-field>
                            <mat-form-field>
                                <input type="email" matInput placeholder="Email
                                    Address" maxlength="254"
                                    formControlName="secondaryEmail">
                                <mat-hint>Example: you@example.com</mat-hint>
                            </mat-form-field>
                        </div>
                        <br> <br>
                        <div>
                            <button *ngIf="!secondaryContactIncluded"
                                mat-raised-button color="primary"
                                (click)="addAdditionalContact()">Add
                                Additional Contact</button>
                            <button *ngIf="secondaryContactIncluded"
                                mat-raised-button color="warn"
                                (click)="removeAdditionalContact()">Remove
                                Additional Contact</button>
                        </div>
                    </mat-card>
                    <div fxLayoutGap="10px" style="padding-top: 10px">

                        <button mat-raised-button matStepperNext color="primary"
                            [disabled]="extOrgContactInfoFormGroup.invalid"
                            (click)="extOrgContactInfoFormGroup.markAsDirty()">Next</button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="extUserFormGroup" [editable]="isVerified &&
                !profileSubmittedSuccessfully"
                [completed]="profileSubmittedSuccessfully">
                <form [formGroup]="extUserFormGroup" #f4="ngForm">
                    <ng-template matStepLabel>Add Registration Info</ng-template>
                    <mat-card fxLayout="column">
                        <mat-card-subtitle>
                            <b>Registration Information for Access</b>
                        </mat-card-subtitle>
                        <br> <br>
                        <mat-checkbox *ngIf="!profileSubmittedSuccessfully"
                            (change)="populateFromContactInfo($event)">
                            Same as Contact Info
                        </mat-checkbox>
                        <mat-form-field>
                            <input type="text" matInput placeholder="First
                                Name" maxlength="150"
                                formControlName="firstName">
                        </mat-form-field>
                        <mat-form-field>
                            <input type="text" matInput placeholder="Last
                                Name" maxlength="150"
                                formControlName="lastName">
                        </mat-form-field>
                        <mat-form-field>
                            <input (keyup)="setConfirmEmailPatternClear()"
                                type="email" matInput placeholder="Email Address
                                * (you will
                                use
                                the email entered here to log in)"
                                maxlength="254" formControlName="email">
                            <mat-hint>Example: you@example.com</mat-hint>
                        </mat-form-field>
                        <mat-form-field
                            *ngIf="extUserFormGroup?.controls['email']?.valid
                            || !profileSubmittedSuccessfully">
                            <input (focus)="setConfirmEmailPattern()"
                                type="email" matInput placeholder="Confirm Email
                                Address" maxlength="254"
                                formControlName="confirmEmail">
                        </mat-form-field>
                    </mat-card>
                    <br> <br>
                    <div *ngIf="showEmailError" style="color: red;
                        font-weight: bold">
                        This email has already been used to sign up for access.
                        To reset your password, click <a target="_blank"
                            [href]="forgotLink">here.</a>
                    </div>
                    <div *ngIf="showGenericError" style="color: red;
                        font-weight: bold">
                        There was an error verifying your email.
                    </div>
                    <br> <br>
                    <mat-checkbox *ngIf="!profileSubmittedSuccessfully"
                        (change)="toggleAgreementToTerms($event)">
                        I agree to LG&E and KU <a
                            href="https://lge-ku.com/terms" target="_blank">Terms
                            of Use</a>
                    </mat-checkbox>
                    <div *ngIf="profileSubmittedSuccessfully">
                        Your request for access has been submitted successfully.
                        A Charitable Contributions Admin will review your
                        request, and you will receive an email with further
                        instructions.
                        <br> <br>
                        <br> <br>
                    </div>
                    <div fxLayoutGap="10px" style="padding-top: 10px">
                        <button mat-raised-button color="warn" title="Back
                            to your login" *ngIf="!profileSubmittedSuccessfully"
                            (click)="closeExternalAccessForm()">Cancel</button>
                        <button mat-raised-button color="primary"
                            *ngIf="!profileSubmittedSuccessfully"
                            [disabled]="extUserFormGroup.invalid ||
                            !agreedToTerms ||
                            profileSubmittedSuccessfully"
                            (click)="verifyEmailUnique()">Verify Email</button>
                        <button mat-raised-button matStepperNext color="primary"
                            *ngIf="!profileSubmittedSuccessfully"
                            [disabled]="extUserFormGroup.invalid ||
                            profileSubmittedSuccessfully ||
                            !agreedToTerms
                            || !isEmailUnique" (click)="submitProfileForms()">
                            Submit to Request Access
                        </button>
                        <button color="primary" mat-raised-button
                            *ngIf="profileSubmittedSuccessfully"
                            (click)="closeExternalAccessForm()">Done</button>
                    </div>
                </form>
            </mat-step>
        </mat-stepper>
    </div>
</div>
